import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import { observable, action } from 'mobx';
import { task } from 'mobx-task';
var RejectDraftDialogStore = (_dec = action.bound, _dec2 = action.bound, _dec3 = task.resolved, _class = /*#__PURE__*/function (_Store) {
  function RejectDraftDialogStore() {
    var _this;
    _classCallCheck(this, RejectDraftDialogStore);
    _this = _callSuper(this, RejectDraftDialogStore, arguments);
    _initializerDefineProperty(_this, "showing", _descriptor, _this);
    _initializerDefineProperty(_this, "jobProgression", _descriptor2, _this);
    _this.rejectDraft = _this.rejectDraft.bind(_this);
    return _this;
  }
  _inherits(RejectDraftDialogStore, _Store);
  return _createClass(RejectDraftDialogStore, [{
    key: "show",
    value: function show(jobProgression) {
      this.jobProgression = jobProgression;
      this.showing = true;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.showing = false;
    }
  }, {
    key: "rejectDraft",
    value: function () {
      var _rejectDraft = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.rootStore.jobProgressionStore.setDraftRejectedProgression(this.jobProgression.jobId);
            case 2:
              this.hide();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function rejectDraft() {
        return _rejectDraft.apply(this, arguments);
      }
      return rejectDraft;
    }()
  }]);
}(Store), _descriptor = _applyDecoratedDescriptor(_class.prototype, "showing", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "jobProgression", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "show", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "show"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hide", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "hide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rejectDraft", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "rejectDraft"), _class.prototype), _class);
export { RejectDraftDialogStore as default };
//# sourceMappingURL=RejectDraftDialogStore.js.map
